// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PaintFillOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"none"}},{"tag":"path","attrs":{"d":"M19.23 18.73L21 16.96l1.76 1.77a2.5 2.5 0 11-3.53 0zM8.88 1.08l11.31 11.31a1 1 0 010 1.42l-8.48 8.48a1 1 0 01-1.42 0l-8.48-8.48a1 1 0 010-1.42l7.78-7.77-2.13-2.13 1.42-1.41zM11 6.03L3.93 13.1h14.14L11 6.03z","fill":"currentColor"}}]},"name":"paint-fill","theme":"outlined"};

const PaintFillOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PaintFillOutlinedSvg} />;
  PaintFillOutlined.displayName = 'PaintFillOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PaintFillOutlined);
